<template>
    <div>
        <div :class="['bug-report-helper', open ? 'fixed' : '']" @click="toggleModal" :title="$t('components.bug-report.title')">
            <div class="bug-report-helper-content"></div>
        </div>
        <BugReport :visible="modalState" @close="toggleModal" :screenshot="screenshot"/>
    </div>
</template>

<script>
import BugReport from "@/components/application/BugReport";
import html2canvas from "html2canvas";

export default {
    name: "BugReportHelper",
    components: {BugReport},
    data() {
        return {
            modalState: false,
            screenshot: null,
            open: false,
        }
    },

    methods: {
        async toggleModal() {
            this.open = !this.open;
            if (this.modalState) {
                this.screenshot = null;
                this.modalState = !this.modalState;
            } else {
                let loader = this.$loading.show();
                await html2canvas(document.body, {
                    imageTimeout: 0,
                    logging: false,
                    useCORS: false,
                    height: document.body.clientHeight,
                    y: window.scrollY
                }).then(canvas => {
                    this.screenshot = canvas;
                    loader.hide();
                    loader = null;
                    this.modalState = !this.modalState;
                });
            }
        },
    }
}
</script>

<style scoped>
.bug-report-helper {
    -webkit-transition: -webkit-transform .5s ease-in-out;
    transition: transform .5s ease-in-out;
    opacity: 0.6;
    position: fixed;
    display: block;
    right: 8px;
    top: calc(10%);
    background-color: #b89453;
    z-index: 1031;
    cursor: pointer;
    border-radius: 50%;
}

.bug-report-helper-content {
    width: 56px;
    height: 56px;
    background-size: 65%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='512' height='512' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet'%3E%3Cg%3E%3Ctitle%3Ebackground%3C/title%3E%3Crect fill='none' id='canvas_background' height='602' width='802' y='-1' x='-1'/%3E%3C/g%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cg id='svg_1' fill='%23000000' transform='translate(0, 512) scale(0.1, -0.1)'%3E%3Cpath fill='%23ffffff' id='svg_2' d='m2385,4676c-309,-73 -541,-283 -636,-576c-25,-76 -32,-119 -38,-220l-6,-124l-81,-46c-111,-62 -135,-80 -240,-182l-91,-88l-84,41c-120,60 -231,172 -286,289c-46,97 -59,144 -68,250c-8,94 -20,133 -52,171c-82,97 -244,97 -326,0c-41,-49 -50,-93 -44,-205c19,-375 262,-732 600,-886c71,-32 77,-37 71,-60c-23,-95 -33,-195 -34,-327l0,-153l-235,0c-190,0 -243,-3 -273,-16c-79,-33 -132,-110 -132,-194c0,-88 38,-152 115,-193c37,-21 57,-22 281,-25l242,-3l6,-212c3,-117 9,-230 12,-252l6,-41l-54,-24c-139,-65 -308,-205 -407,-339c-52,-69 -116,-194 -147,-283c-25,-74 -54,-211 -54,-256c0,-22 3,-19 23,19c34,64 93,102 166,107c32,2 75,-1 94,-7c45,-15 104,-73 127,-125l19,-41l0,35c2,55 27,138 67,220c44,90 168,219 253,264c53,28 55,29 68,10c7,-10 41,-62 75,-114c79,-122 279,-324 398,-402c167,-110 351,-188 543,-230c148,-32 446,-32 594,0c192,42 374,119 543,230c119,78 318,279 398,402c34,52 68,104 75,114c13,19 15,18 67,-10c75,-40 187,-149 233,-225c43,-73 87,-202 87,-257l0,-37l28,55c38,74 92,112 171,118c32,2 75,-1 94,-7c42,-14 104,-72 123,-115l13,-31l1,26c1,95 -57,289 -124,415c-57,107 -114,180 -212,274c-88,84 -156,131 -257,181l-69,34l6,40c3,22 9,135 12,252l6,212l242,3c236,3 242,4 286,28c67,38 103,96 108,174c5,71 -14,120 -65,168c-56,54 -82,58 -338,58l-235,0l0,153c-1,132 -11,234 -34,327c-6,23 -1,27 61,55c344,152 590,513 610,891c6,112 -3,156 -44,205c-94,111 -284,92 -350,-35c-8,-16 -21,-79 -29,-139c-7,-61 -21,-133 -30,-161c-55,-170 -199,-325 -364,-392l-55,-23l-75,78c-87,90 -158,145 -256,199l-69,37l-6,125c-5,103 -12,142 -38,220c-91,270 -281,460 -549,550c-88,30 -110,33 -237,36c-96,3 -159,-1 -200,-10zm238,-416c192,-31 335,-179 360,-372l7,-48l-430,0l-430,0l7,48c27,210 194,364 413,381c8,0 41,-3 73,-9zm-273,-2115l0,-1265l-21,0c-32,0 -165,47 -243,86c-241,121 -418,316 -519,570c-70,178 -72,195 -72,804l0,545l28,82c54,161 169,295 318,373c109,57 167,68 352,69l157,1l0,-1265zm789,1250c35,-9 98,-33 141,-55c185,-97 306,-267 340,-480c13,-83 13,-936 0,-1050c-19,-170 -83,-346 -177,-487c-89,-135 -252,-278 -399,-352c-85,-43 -220,-91 -253,-91l-21,0l0,1265l0,1265l153,0c100,0 174,-5 216,-15z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.bug-report-helper:hover {
    opacity: 1;
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
}

.bug-report-helper.fixed {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
}
</style>
